module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/350.0fa8db0c.png";